module.exports = __webpack_public_path__ + "img/illustration.76f4390b.png";